import React, { Component } from 'react';
import { Button, message, Modal, DatePicker, Select } from 'antd';
import moment from 'moment';

const Option = Select.Option;

class ExportSelectRangeModal extends Component {
    state = {
        visible: false,
        values: [],
    }

    show = () => {
        this.setState({
            values: [],
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false, year:undefined, quarter:undefined });
    }

    handleCheckChange = (values) => {
        this.setState({ values });
    }

    submit = () => {
        const { exportSelectRange } = this.props;
        const { year, quarter} = this.state;
        console.log(this.state);
        if (!year || !quarter) {
            message.warning('请选择导出的年和季度！');
            return;
        }
        exportSelectRange({year, quarter});
        this.hide();
    }

    setOpenState = () => {
        this.setState({
            yearOpen:!this.state.yearOpen
        });
      };
    
    yearChangeRender = (v) => {
        this.setState({
        // yearOpen: false,
        year: moment(v).format("YYYY"),
        });
    }; 

    handleSelectChange = (e,mode)=>{
        this.setState({
            [mode]:e,
        })
    }

    render() {
        const { visible, year, yearOpen, quarter } = this.state;
        const statisticsDateOption = [];
        const trueYear = moment().format('YYYY');
        let start = 2016,
            end = (trueYear || 2016);
        for (; start <= end; start++) {
            statisticsDateOption.push(<Option key={start}>{start}</Option>);
        }
        return (
            <Modal
                title="选择导出季度"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="400px"
                footer={
                    [<Button key="back" onClick={this.hide}>取消</Button>,
                <Button type="primary" onClick={this.submit}>确定</Button>]
            }
            >
                <div>请选择要导出的季度:</div>
                <div style={{padding:'10px 0'}}>
                <Select
                    placeholder="请选择"
                    value={year}
                    style={{width: '45%'}}
                    onChange={value => this.handleSelectChange(value, 'year')}
                >
                    {statisticsDateOption}
                </Select>
                    {/* <DatePicker  
                       mode='year'    
                       format="YYYY"  
                        placeholder="请选择年度"
                        value={year ? moment(year) : undefined}
                        onChange= {this.yearChangeRender}
                        style={{width: '45%'}}
                        // onPanelChange={this.yearChangeRender}
                        // onOpenChange={() => this.setOpenState()}
                        // open={yearOpen}
                        allowClear={false}
                   /> */}
                    <span className="ant-divider" />
                    <Select
                       allowClear={true}
                       placeholder="请选择"
                       style={{width: '45%'}}
                       value={quarter}
                       onChange={value => this.handleSelectChange(value,'quarter')}
                    >
                        <Option value="1">Q1</Option>
                        <Option value="2">Q2</Option>
                        <Option value="3">Q3</Option>
                        <Option value="4">Q4</Option>
                    </Select>
                </div>
            </Modal>
        );
    }
}

export default ExportSelectRangeModal;



// WEBPACK FOOTER //
// ./src/components/homePage/statement/ExportSelectRangeModal.js